import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAnnotationNumbers32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconAnnotationNumbers32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.93 11.304V21h2.048V9.8H7.282l-2.288 5.056h2.144l1.504-3.552zM15 13a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1m1-5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAnnotationNumbers32);
